var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:mail-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.16234 30.2968C5.35178 30.2968 4.65765 30.0079 4.07994 29.4302C3.50223 28.8525 3.21386 28.1589 3.21485 27.3493V9.6643C3.21485 8.85373 3.5037 8.1596 4.08141 7.58189C4.65912 7.00418 5.35276 6.71582 6.16234 6.7168H29.7423C30.5529 6.7168 31.247 7.00565 31.8247 7.58336C32.4024 8.16107 32.6908 8.85472 32.6898 9.6643V27.3493C32.6898 28.1598 32.401 28.854 31.8233 29.4317C31.2456 30.0094 30.5519 30.2978 29.7423 30.2968H6.16234ZM17.9523 19.9805L6.16234 12.6118V27.3493H29.7423V12.6118L17.9523 19.9805ZM17.9523 17.033L29.7423 9.6643H6.16234L17.9523 17.033ZM6.16234 12.6118V9.6643V27.3493V12.6118Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailDoodle);
export default __webpack_public_path__ + "static/media/mailDoodle.0efed0c9b020acdb887fa10c7f9bfd12.svg";
export { ForwardRef as ReactComponent };